import React from "react";
import ReactStarRatings from "react-star-ratings";
import PropTypes from "prop-types";

const Rating = ({ style, className, id, value, color, startsNumber, starSize, starSpacing }) => {
  return (
    <ReactStarRatings
      style={style}
      className={className}
      name={id}
      rating={(value || 0) / 20}
      starRatedColor={color}
      numberOfStars={startsNumber}
      starDimension={starSize}
      starSpacing={starSpacing}
    />
  );
};

Rating.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  value: PropTypes.number,
  color: PropTypes.string,
  startsNumber: PropTypes.number,
  starSize: PropTypes.number,
  starSpacing: PropTypes.number,
  onChange: PropTypes.func
};
Rating.defaultProps = {
  style: {},
  color: "#FCAB3D",
  startsNumber: 5,
  starSize: 30,
  starSpacing: 5
};

export default Rating;
